/**
 * Checkbox Component
 */

/* tslint:disable:jsx-no-lambda */

import { getColorSchemeClassName } from '../../../styles/color-schemes';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';
import './styles.scss';

import { IconCheck, IconCheckMultiple } from '../../images/Icon';
import { Span } from '../../text/Label';

export interface ICheckboxProps {
  checked?: boolean;
  className?: string;
  colorScheme?: 'light' | 'white';
  defaultChecked?: boolean;
  input?: WrappedFieldInputProps;
  meta?: WrappedFieldMetaProps<any>;
  multiple?: boolean;
  name: string;
  size?: 'normal' | 'large';
  onChange?(checked: boolean, input: HTMLInputElement): void;
}

interface IOwnState {
  checked: boolean;
}

const classes = new BEM('checkbox');

export default class Checkbox extends React.Component<ICheckboxProps, IOwnState> {
  static defaultProps: Partial<ICheckboxProps> = {
    colorScheme: 'light',
    size: 'normal',
  };
  private input: HTMLInputElement;

  constructor(props) {
    super(props);

    this.state = {
      checked: false,
    };
  }

  componentDidMount() {
    if (this.props.defaultChecked) {
      this.onChange();
    }
  }

  onChange = () => {
    this.setState({
      checked: !this.state.checked,
    }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.checked, this.input);
      }
    });
  }

  render() {
    const {
      children,
      className,
      colorScheme,
      input,
      meta,
      size,
      multiple,
      checked,
    } = this.props;

    const name = input ? input.name : this.props.name;
    const Icon = multiple ? IconCheckMultiple : IconCheck;

    const inputControlProps: any = {
      onChange: this.onChange,
      checked: this.state.checked,
    };

    if (input) {
      inputControlProps.onChange = (e) => { this.onChange(); input.onChange(e, e.target.value, null); };
      inputControlProps.checked = input.value;
    } else if (checked != null) {
      inputControlProps.checked = checked;
    }

    const extraClasses = classNames(
      colorScheme && getColorSchemeClassName(colorScheme, 'checkbox'),
      className,
    );

    const labelClasses = new BEM('label');

    return (
      <div {...classes('', size, extraClasses) }>
        <input
          ref={(node) => this.input = node!}
          type="checkbox"
          id={name}
          name={name}
          {...inputControlProps}
        />
        <label htmlFor={name} {...classes('styled-input') }>
          {meta && (
            (meta.error &&
              <Span {...labelClasses('', 'error') } size="medium" textColor="dangerous">{meta.error}</Span>) ||
            (meta.warning &&
              <Span {...labelClasses('', 'warning') } size="medium">{meta.warning}</Span>)
          )}
          <div {...classes('styled-input__fill') } />
          <Icon />
        </label>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/forms/Checkbox/index.tsx